import useTextOverflow from '@util/hooks/useTextOverflow';
import { ProductDocument } from 'models/product';
import { cx } from 'class-variance-authority';
import sanitize from 'sanitize-html';

const ProductDescription = ({
  product,
  hideReadMore = false,
  hideTitle = false,
}: {
  product: ProductDocument;
  hideReadMore?: boolean;
  hideTitle?: boolean;
}) => {
  return (
    <>
      {!hideTitle && (
        <h2 className="mb-[1rem] mt-0 text-[1.8rem] font-semibold sm:mt-[2rem]">
          Description
        </h2>
      )}

      <div>
        {product.description_html ? (
          <>
            {/* Editor content class so it matches what people saw in the create listing tool  */}
            <div
              className={`editor-content overflow-x-auto text-[1.6rem] [&>ul]:list-inside [&>ul]:list-disc`}
              dangerouslySetInnerHTML={{
                __html: sanitize(product.description_html, {
                  allowedTags: sanitize.defaults.allowedTags.filter(
                    (tag) => tag !== 'a'
                  ),
                }),
              }}
            />
          </>
        ) : product.description ? (
          <>
            <p className={'overflow-x-auto whitespace-pre-line text-[1.6rem]'}>
              {product.description}
            </p>
          </>
        ) : (
          <span className="italic"> No description available</span>
        )}
      </div>
    </>
  );
};

export default ProductDescription;
